<template>
    <div class="everyspace">
        <div class="everyhead">
            <h1>加入孺教网 加速你成长</h1>
            <div class="everyfind clear">
                <div style="position: relative;">
                    <i class="iconfont iconsousuo"></i>
                    <input type="text" placeholder="搜索空间" v-model="inputtext">
                    <button @click="search">搜索</button>
                </div>
                <!-- <div>
                    或
                    <button>+  加入学校/班级</button>
                </div> -->
            </div>
            <div class="hotfind">热门搜索：孺教网官方的空间 孺教网 ...</div>
            <!-- <div style="width: 1200px;margin:0 auto;position: relative;">
                <div class="foundspace">
                    <i class="iconfont iconchuangjian"></i>
                    创建空间
                </div>
           </div> -->
        </div>
        <div v-if="show">
            <every-footer-two></every-footer-two>
        </div>
        <div v-else>
            <every-foot :alllist='alllist'></every-foot>
        </div>
        <div v-show="ashow" class="divlast">
            <svg class="icon" aria-hidden="true">
                <use xlink:href="#iconquesheng-"></use>
            </svg>
        </div>
    </div>
</template>

<script>
import URL from '../../api/index'
// 引入底部展示区域
import EveryFoot from '../../components/space/every-footer'
import EveryFooterTwo from '../../components/space/every-footer_two'
export default {
    components:{
        EveryFoot,
        EveryFooterTwo
    },
    data(){
        return{
            inputtext:'',
            alllist:'',
            Userifon:'',
            UserInfo:'',
            show:true,
            ashow:false
        }
    },
    mounted(){
        this.UserInfo = JSON.parse(window.localStorage.getItem("info"));
    },
    methods:{
        search(){
            var that =this
            var searchSpaceList_data={
                token:that.UserInfo.token,
                keywords:that.inputtext
            }
            // 空间搜索
            this.$post(URL.searchSpaceList,searchSpaceList_data).then(res=>{
                that.alllist = res.result.list
                
                
                that.show = false
                if(that.alllist.length != 0){
                    that.ashow = false
                } else{
                    that.ashow = true
                }
            }) 
        },

    }
}
</script>

<style lang="less" scoped>
/*人人通空间*/

.everyhead {
    width: 100%;
    height: 355px;
    padding-top: 95px;
    background-image: linear-gradient(79deg, #1381f2 0%, #58e6fb 100%), linear-gradient( #8ee3ff, #8ee3ff);
}

.everyhead h1 {
    color: #FFF;
    font-size: 42px;
    letter-spacing: 28px;
    font-weight: normal;
    text-align: center;
}

.everyfind {
    width: 900px;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    margin-top: 65px;
}

.everyfind>div:nth-child(1) input {
    width: 870px;
    height: 48px;
    border: none;
    color: #FFF;
    border-radius: 25px;
    background: #6ec4f9;
    font-size: 16px;
    text-indent: 3em;
    outline: none;
}


.everyfind>div:nth-child(1) input::placeholder {
    color: #FFF;
}

.everyfind>div:nth-child(1) i {
    position: absolute;
    top: 16px;
    left: 18px;
    font-size: 21px;
    color: #FFF;
}

.everyfind>div:nth-child(1) button {
    width: 120px;
    height: 50px;
    color: #FFF;
    font-size: 16px;
    line-height: 50px;
    text-align: center;
    cursor: pointer;
    border: none;
    margin: 2px 0 0 -120px;
    background: #2c84ff;
    outline: none;
    border-top-right-radius: 25px;
    border-bottom-right-radius: 25px;
}

.everyfind>div:nth-child(2) {
    color: #FFF;
    font-size: 20px;
    line-height: 50px;
    margin-left: 25px;
}

.everyfind>div:nth-child(2) button {
    width: 180px;
    height: 50px;
    color: #FFF;
    font-size: 16px;
    line-height: 50px;
    text-align: center;
    cursor: pointer;
    border: none;
    background: #2c84ff;
    outline: none;
    border-radius: 25px;
    margin-left: 20px;
}

.hotfind {
    width: 900px;
    margin: 20px auto;
    color: #FFF;
    font-size: 14px;
    text-indent: 4em;
}

.foundspace {
    position: absolute;
    bottom: -190px;
    right: 0;
    width: 130px;
    border-radius: 17px;
    text-align: center;
    line-height: 34px;
    background: #2c84ff;
    cursor: pointer;
    color: #FFF;
    // margin-top: 76px;
}

.foundspace i {
    font-size: 20px;
}

.everyspacehotlist {
    width: 1200px;
    margin: 20px auto;
    background: #f5f6f8;
}

.everyspacehotlistb {
    display: none;
}

.seeklist {
    display: block;
}

.hotlist {
    width: 390px;
    height: 140px;
    background: #FFF;
    border-radius: 4px;
    float: left;
    margin: 25px 12px 0 0;
    cursor: pointer;
    -webkit-box-shadow: 2px 2px 14px #eaebed;
    -moz-box-shadow: 2px 2px 14px #eaebed;
    -ms-box-shadow: 2px 2px 14px #eaebed;
    box-shadow: 2px 2px 14px #eaebed;
}

.everylist .hotlist:nth-child(3n) {
    margin-right: 0;
}

.everylist {
    margin-bottom: 40px;
}

.hotlist>div:nth-child(1) {
    width: 120px;
    height: 120px;
    overflow: hidden;
    border-radius: 4px;
    float: left;
    margin: 10px 10px 0 10px;
}

.hotlist>div:nth-child(2) {
    float: left;
    width: 240px;
    margin-top: 10px;
}

.hotlist>div:nth-child(2)>div:nth-child(1) {
    color: #4b4b4b;
    font-size: 16px;
    line-height: 35px;
}

.hotlist>div:nth-child(2)>div:nth-child(2) {
    color: #898989;
    font-size: 14px;
    line-height: 20px;
    overflow: hidden;
    -webkit-line-clamp: 2;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
}

.hotlist>div:nth-child(2)>div:nth-child(3) {
    margin-top: 20px;
}

.hotlist>div:nth-child(2)>div:nth-child(3) div {
    float: right;
    width: 60px;
    height: 26px;
    line-height: 26px;
    text-align: center;
    color: #939393;
    font-size: 14px;
    border: 1px solid #939393;
    border-radius: 4px;
}

.hotlist>div:nth-child(2)>div:nth-child(3) span:nth-child(1) {
    display: inline-block;
    border-right: 1px solid #939393;
    padding-right: 8px;
}

.everytitle {
    float: left;
}

.everyusertype {
    float: left;
    width: 36px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border-radius: 4px;
    font-size: 12px;
    color: #FFF;
    background: #ffa944;
    margin-top: 8px;
    margin-left: 10px;
}

.el-menu--horizontal {
    border-bottom: 0!important;
}

.clear:after{
 content: '';
 display: block;
 clear: both;
}
.divlast{
    margin: 30px auto;
    width: 300px;
}
</style>
